import HP from "../host";
import { ApiService } from "./API";
const api = new ApiService(`${HP.request}://${HP.host}/api/v1`);
const BackupService = {
  getBackupLogs: async () => {
    return await api.get("/backup/logs");
  },
};
export default BackupService;
